export default __webpack_public_path__ + "static/media/tom-chien-rizecky.61516c32.jpg";